const sessionRemainingTimeInMinConfig = {
    firstStep: 5,
    secondStep: 2,
    thirdStep: 1,
};

export default sessionRemainingTimeInMinConfig;